module.exports = __webpack_public_path__ + "img/aste_orange.png";